const socialType = [
  {
    name: "Facebook",
    value: "facebook"
  },
  {
    name: "Instagram",
    value: "instagram"
  },
  {
    name: "Twitter",
    value: "twitter"
  }
];
export default socialType;
